import React, { useState, useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab, setSearchQuery } from 'redux/reducers/mailerLayoutReducer';
import ReportsTable from 'components/Admin/Mailer/ReportsTable';
import ReportsTableMobile from 'components/Admin/Mailer/ReportsTable/Mobile';
import ReportForm from 'components/Admin/Mailer/ReportForm';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function MailerReports() {
  const [showReportForm, setShowReportForm] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('reports'));
    store.dispatch(setSearchQuery(''));
  }, []);

  if (showReportForm) {
    return (
      <div className="bg-gray">
        <ReportForm close={() => setShowReportForm(false)} />
      </div>
    );
  }

  return (
    <div className="bg-gray">
      {isMobile
        ? <ReportsTableMobile openReportForm={() => setShowReportForm(true)} />
        : <ReportsTable openReportForm={() => setShowReportForm(true)} />}
    </div>
  );
}
